var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('v-progress-linear',{attrs:{"color":"warning","height":"3","indeterminate":""}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }